import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { Carat } from "./Basic/Carat";
import {Shape} from "./Basic/Shape"
import {Color} from "./Basic/Color"
import { Clarity } from "./Basic/Clarity";
import { Lab } from "./Basic/Lab";
import { Shortcut } from "./Basic/Shortcut";
import { Finish } from "./Basic/Finish";
import { Flour } from "./Basic/Flour";
import { Location } from "./Basic/Location";
import { Availibility } from "./Basic/Availibility";
export const Basic = ({formik,language,option,setLoader,errorMsg,setErrorMsg}) => {
    // console.log(formik,"formik")
       return (
        <>
            <Accordion className="search_accordion" defaultActiveKey="1">
                <Card>
                    <Accordion.Toggle className="sticky-top" style={{top:"64px"}} as={Card.Header} eventKey="1" key="1">
                        {language.BASIC_BASIC}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body >
                            <Shape language={language} setLoader={setLoader} errorMsg={errorMsg} setErrorMsg={setErrorMsg} />
                            <Carat language={language} formik={formik} errorMsg={errorMsg} setErrorMsg={setErrorMsg}/>
                            <Color language={language} formik={formik} option={option}/>
                            <Clarity language={language}/>
                            <Lab language={language}/>
                            {/* <Availibility language={language}/> */}
                            <Shortcut language={language} formik={formik} option={option}/>
                            <Finish language={language}/>
                            <Flour language={language}/>
                            <Location language={language} formik={formik}/>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </>
    );
};
